import React from 'react'

function ResultsDifferences({
  description,
  backgroundColor,
  colorTitle,
  colorContent,
  id,
}) {
  return (
    <div
      id={id}
      data-aos="fade-right"
      className="flex-center padding-100 text-center"
    >
      <div
        className="flex-center flex-column flex__gap-50 width-70 box-shadow cards"
        style={{ background: backgroundColor }}
      >
        <h2 className="title-main text-center" style={{ color: colorTitle }}>
          Resultados e Impacto
        </h2>
        <p style={{ color: colorContent }}>{description}</p>
      </div>
    </div>
  )
}

export default ResultsDifferences
